export abstract class Model {}



// WEBPACK FOOTER //
// ./src/app/model/model.class.ts